import Axios from 'axios';

export default {
    getEventBetTypesMarkets(eventId, betType, matchWinner) {
        betType = betType === 'all markets' ? undefined : betType;
        return Axios.get(`/api/liveinplay/events/${eventId}/eventbettypesmarkets?betTypeCategory=${betType}&matchwinner=${matchWinner}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                this.error = error;
            })
    }
}